export enum KrpanoEventName {
  Ready = 'pano_ready',
  ViewChange = 'pano_view',
  HotSpotClick = 'pano_hot-click',
  SceneProgress = 'pano_scene_progress',
}
